import { render, staticRenderFns } from "./index.vue?vue&type=template&id=49fa7ce0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fa7ce0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/zippo-mdm-vue-prd/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49fa7ce0')) {
      api.createRecord('49fa7ce0', component.options)
    } else {
      api.reload('49fa7ce0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=49fa7ce0&scoped=true", function () {
      api.rerender('49fa7ce0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/organization/index.vue"
export default component.exports